import { connect } from 'react-redux';

import {
  showToast,
  hideToast,
} from 'modules/Notifications';
import Notifications from '../components/Notifications.jsx';

const mapDispatchToProps = dispatch => {
  return {
    hideToast: () => dispatch(hideToast()),
    showToast: (title, message, dismissible, state) => {
      return dispatch(showToast(title, message, dismissible, state));
    },
  };
};

const mapStateToProps = state => ({
  notification: state.notifications.notification,
  showing: state.notifications.showing,
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
